import { render, staticRenderFns } from "./popup-import.vue?vue&type=template&id=09561f4b&scoped=true"
import script from "./popup-import.vue?vue&type=script&lang=js"
export * from "./popup-import.vue?vue&type=script&lang=js"
import style0 from "./popup-import.vue?vue&type=style&index=0&id=09561f4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09561f4b",
  null
  
)

export default component.exports